/**
 * Recommendation-card draft headers come from the gateway as
 * `Draft to {FirstName} — editable`. That is wrong for self-reflection
 * answers (manager-style label on "notes for yourself" content).
 */

/** True when the draft reads as outbound mail to someone (`Hi Name, …`). */
export function isOutboundCoachingDraft(draft: string | undefined | null): boolean {
  const text = (draft ?? '').trim();
  if (!text) {
    return false;
  }
  return /^(hi|hello|hey)\s+[A-Za-z][\w'.-]*/i.test(text);
}

/**
 * Prefer a coaching-example label for self-reflection / checklist drafts;
 * keep gateway `Draft to X` only for real outbound notes.
 */
export function resolveRecommendationDraftLabel(input: {
  draftMessage?: string | null;
  draftLabel?: string | null;
  body?: string | null;
  fallbackLabel: string;
  exampleLabel: string;
}): string {
  const draft = input.draftMessage ?? '';
  const body = input.body ?? '';
  const gatewayLabel = input.draftLabel?.trim();

  const selfReflection =
    /\b(self-reflection|yourself|your own|personal work patterns)\b/i.test(body) ||
    /\b(ask yourself|check if your|clarify your|offer yourself)\b/i.test(draft);

  if (selfReflection || !isOutboundCoachingDraft(draft)) {
    return input.exampleLabel;
  }

  return gatewayLabel || input.fallbackLabel;
}
